import { GetApiData } from "utils/http-client";


export const getAllTimeStamps = async (id, type, limit, page) => {
    return await GetApiData(`/timestamp?sourceType=${type}&sourceId=${id}&limit=${limit}&page=${page}`, 'GET', null, true);
};

